import React, { Component, Fragment } from 'react';
import './SLO.Module.scss';
import 'react-tippy/dist/tippy.css';

import {
    Tooltip,
  } from 'react-tippy';


class SLO extends Component {

    render() {


        let active = this.props.lesson.slo_programmeren;

        if(!active || active == 'null') {
            active = [];
        }

        return (
        <Fragment>
            {/* <h4>SLO</h4> */}
            <div styleName='grid'>
                <div styleName='grid-heading'>Algoritme</div>
                <Tooltip
                // options
                title="Leert hoe complex het is om echte problemen om te zetten in programma's."
                position='top'
                arrow='true'
                size='small'
                >
                <div styleName={`grid-item ${active.includes('A1') ? 'active' : ''}`}>A1</div>
                </Tooltip>
                <Tooltip
                // options
                title='Leert dat ideëen helder kunnen lijken, maar wellicht nog steeds verkeerd "begrepen" kunnen worden door een computer.'  
                position='top'
                arrow='true'
                size='small'
                >
                <div styleName={`grid-item ${active.includes('A2') ? 'active' : ''}`}>A2</div>
                </Tooltip>
                <div styleName={`grid-item ${active.includes('A3') ? 'active' : ''}`}>A3</div>
                <div styleName={`grid-item ${active.includes('A4') ? 'active' : ''}`}>A4</div>
                <div styleName={`grid-item ${active.includes('A5') ? 'active' : ''}`}>A5</div>
                <div styleName={`grid-item ${active.includes('A6') ? 'active' : ''}`}>A6</div>
                <div styleName={`grid-item ${active.includes('A7') ? 'active' : ''}`}>A7</div>
                <div styleName={`grid-item ${active.includes('A8') ? 'active' : ''}`}>A8</div>
                <div styleName={`grid-item ${active.includes('A9') ? 'active' : ''}`}>A9</div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Decompositie</div>
                <div styleName={`grid-item ${active.includes('D1') ? 'active' : ''}`}>D1</div>
                <div styleName={`grid-item ${active.includes('D2') ? 'active' : ''}`}>D2</div>
                <div styleName={`grid-item ${active.includes('D3') ? 'active' : ''}`}>D3</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Patronen</div>
                <div styleName={`grid-item ${active.includes('P1') ? 'active' : ''}`}>P1</div>
                <div styleName={`grid-item ${active.includes('P2') ? 'active' : ''}`}>P2</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Herhaling</div>
                <div styleName={`grid-item ${active.includes('H') ? 'active' : ''}`}>H</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Fouten</div>
                <div styleName={`grid-item ${active.includes('F1') ? 'active' : ''}`}>F1</div>
                <div styleName={`grid-item ${active.includes('F2') ? 'active' : ''}`}>F2</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Voorwaarden</div>
                <div styleName={`grid-item ${active.includes('V1') ? 'active' : ''}`}>V1</div>
                <div styleName={`grid-item ${active.includes('V2') ? 'active' : ''}`}>V2</div>
                <div styleName={`grid-item ${active.includes('V3') ? 'active' : ''}`}>V3</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Abstractie</div>
                <div styleName={`grid-item ${active.includes('AB1') ? 'active' : ''}`}>AB1</div>
                <div styleName={`grid-item ${active.includes('AB2') ? 'active' : ''}`}>AB2</div>
                <div styleName={`grid-item ${active.includes('AB3') ? 'active' : ''}`}>AB3</div>
                <div styleName={`grid-item ${active.includes('AB4') ? 'active' : ''}`}>AB4</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Voorwaarden</div>
                <div styleName={`grid-item ${active.includes('FU1') ? 'active' : ''}`}>FU1</div>
                <div styleName={`grid-item ${active.includes('FU2') ? 'active' : ''}`}>FU2</div>
                <div styleName={`grid-item ${active.includes('FU3') ? 'active' : ''}`}>FU3</div>
                <div styleName={`grid-item ${active.includes('FU4') ? 'active' : ''}`}>FU4</div>
                <div styleName={`grid-item ${active.includes('FU5') ? 'active' : ''}`}>FU5</div>
                <div styleName={`grid-item ${active.includes('FU6') ? 'active' : ''}`}>FU6</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Abstractie</div>
                <div styleName={`grid-item ${active.includes('VA1') ? 'active' : ''}`}>VA1</div>
                <div styleName={`grid-item ${active.includes('VA2') ? 'active' : ''}`}>VA2</div>
                <div styleName={`grid-item ${active.includes('VA3') ? 'active' : ''}`}>VA3</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Representatie</div>
                <div styleName={`grid-item ${active.includes('REP1') ? 'active' : ''}`} >REP1</div>
                <div styleName={`grid-item ${active.includes('REP2') ? 'active' : ''}`}>REP2</div>
                <div styleName={`grid-item ${active.includes('REP3') ? 'active' : ''}`}>REP3</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
            </div>
        </Fragment>
        );
    }
}

export default SLO;